import './style/file-to-ifram.scss'
import { random } from 'public/utils'
import { canTransformPdfTypeList } from '../../preview'

export default {
  props: {
    fileItem: Object
  },
  data() {
    return {
      timer: null,
      loading: true,
      loadingText: '',
      iframeSrc: null,
      isError: false
    }
  },
  computed: {
    canTransformPdfTypeList() {
      const type = String(this.$props.fileItem.extendName).toLowerCase()
      return canTransformPdfTypeList.includes(type)
    }
  },
  render(h) {
    const createError = errorText => {
      const keyImageAttrs = {
        class: 'kye-file-to-iframe-empty-image',
        props: {
          showToolbar: false,
          emptyText: errorText,
          config: {
            height: '100%'
          }
        }
      }
      return (
        <kye-image {...keyImageAttrs}>
          <div slot="img" class="imgbox">
            <div>
              <div class="no-img">
                <i class="layout layout-icon_magnifier"></i>
                <span class="no-img-txt">{errorText}</span>
              </div>
            </div>
          </div>
        </kye-image>
      )
    }
    const createBeforeIframeLoadContent = () => {
      if (this.loading) {
        if (this.loadingText) {
          return createError(this.loadingText)
        } else {
          return <div v-loading={true} element-loading-text="文件转换中..."></div>
        }
      }
      return null
    }
    const beforeIframeLoadContent = createBeforeIframeLoadContent()
    const createTransformFail = () => {
      if (!this.isError) {
        return null
      }
      if (this.fileItem.previewErrorSlot && typeof this.fileItem.previewErrorSlot === 'function') {
        return this.fileItem.previewErrorSlot(h, { fileItem: this.$props.fileItem })
      } else {
        return createError('该文件类型不支持预览')
      }
    }
    const transformFailContent = createTransformFail()
    const showIframe = !this.isError && this.iframeSrc
    return (
      <div class="kye-file-to-iframe-wrap">
        {beforeIframeLoadContent}
        {transformFailContent}
        {showIframe ? (
          <iframe
            ref="iframe"
            style={{ display: this.loading ? 'none' : 'block' }}
            src={this.iframeSrc}
            on-load={this.iframeLoad}
            frameborder="0"></iframe>
        ) : null}
      </div>
    )
  },
  methods: {
    setLoadingText(val) {
      this.loadingText = val
    },
    setLoading(val) {
      this.loading = val
    },
    iframeLoad() {
      this.$nextTick(() => {
        console.log('加载成功--------')
        this.setLoading(false)
        this.$emit('iframe-load-success')
      })
    },
    clearTimer() {
      clearTimeout(this.timer)
      this.timer = null
    },
    transFromFilteToIframeSrc() {
      if (!this.canTransformPdfTypeList) {
        this.isError = true
        this.setLoading(false)
        this.setLoadingText('')
        return
      }
      this.setLoading(true)
      this.setLoadingText('')
      if (!this.$props.fileItem.bizCode) {
        this.setLoadingText('缺少bizCode')
        this.clearTimer()
        return
      }
      if (!this.$props.fileItem.bizId) {
        this.clearTimer()
        this.setLoadingText('缺少bizId')
        return
      }
      this.previewDocument(this.$props.fileItem.bizCode, this.$props.fileItem.bizId, this.$props.fileItem.id)
    },
    async previewDocument(bizCode, bizId, id) {
      try {
        const data = await this.$http('filetool.filetool.preview', {
          vo: {
            bizCode,
            bizId,
            id
          },
          time: random()
        })
        if (data) {
          const { id, bizCode, bizId } = data
          if (id) {
            const res = await this.$http('system.file.sign', {
              bizCode,
              bizId,
              createdBy: 0
            })
            if (res) {
              const isUrl = data.visit.includes('http')
              let url = data.visit + '/' + res
              const { pdfParams = '#view=FitH' } = this.fileItem || {}
              // const { pdfParams = '#toolbar=0&view=FitH' } = this.fileItem || {}
              if (isUrl) {
                if (url.indexOf('?') > -1) {
                  this.iframeSrc = url + '&inline=true' + pdfParams
                } else {
                  this.iframeSrc = url + '?inline=true' + pdfParams
                }
                this.setLoadingText('')
              } else {
                this.setLoadingText('文件错误无法预览')
              }
            } else {
              this.setLoadingText('文件授权失败')
            }
            this.clearTimer()
          } else {
            // 如果不存在id 则说明文件还在准备中，需要继续调用
            let that = this
            this.timer = setTimeout(() => {
              this.previewDocument(that.$props.fileItem.bizCode, that.$props.fileItem.bizId, that.$props.fileItem.id)
              clearTimeout(this.timer)
            }, 3000)
          }
        } else {
          this.setLoadingText('文件不存在')
          this.clearTimer()
        }
      } catch (error) {
        console.log(error)
        this.clearTimer()
        this.setLoading(false)
        this.isError = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-preview/component/preview-wrapper/file-to-iframe.js